export default {"src":"/_next/static/media/Access_Storage_Logo_RGB.20987a6d.svg","height":250,"width":550};